export default function getFormattedDateWithLastDay(
	year: number,
	month: string,
) {
	const monthMap: Record<string, number> = {
		January: 1,
		February: 2,
		March: 3,
		April: 4,
		May: 5,
		June: 6,
		July: 7,
		August: 8,
		September: 9,
		October: 10,
		November: 11,
		December: 12,
	};

	const normalizedMonth =
		month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();

	const monthNumber = monthMap[normalizedMonth];

	if (!monthNumber) {
		throw new Error(`Invalid month name: ${month}`);
	}

	const firstDay = `${year}-${monthNumber}-1`;

	const lastDayDate = new Date(year, monthNumber, 0); // Month is 0-based
	const lastDay = `${year}-${monthNumber}-${lastDayDate.getDate()}`;

	return { firstDay, lastDay };
}
